import React, { useState, useEffect } from "react";
import { downloadFile } from "../../Constant/Constant";

const BulkUploadModel = ({ open, onClose, setSelectedFile , selectedFile , onImport , fileLink ,fileName }) => {

  const [error, setError] = useState("");
  const [isDragging, setIsDragging] = useState(false);


  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && (file.name.endsWith(".xlsx") || file.name.endsWith(".xls"))) {
      setSelectedFile(file);
      setError("");
    } else {
      setError("Please upload a valid Excel file (.xlsx or .xls)");
      setSelectedFile(null);
      e.target.value = "";
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && (file.name.endsWith(".xlsx") || file.name.endsWith(".xls"))) {
      setSelectedFile(file);
      setError("");
    } else {
      setError("Please upload a valid Excel file (.xlsx or .xls)");
      setSelectedFile(null);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleImport = () => {
    if (!selectedFile) {
      setError("Please select a valid Excel file before importing.");
      return;
    }
    onImport(selectedFile);
    onClose();
  };
  const handleDownloadTemplate = () => {
    downloadFile(fileLink, fileName);
  };
  

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="bulk-upload-title"
    >
      <div className="bg-white rounded-[10px] shadow-xl w-[560px]   p-6 transform transition-all">
        {/* Header */}
        <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
          <h2
            id="bulk-upload-title"
            className="text-lg font-medium text-green-700"
          >
            Bulk Upload
          </h2>
          <button
            onClick={()=>{
              setSelectedFile(null)
              onClose()
          }}
            className="text-red-600 bg-white px-2 focus:outline-none  rounded-full p-1"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* File Upload */}
        <div className="flex items-center gap-4 my-8">
          <label
            htmlFor="file-upload"
            className="text-sm font-medium text-gray-900 w-20"
          >
            File
          </label>
          <div className="relative flex items-center w-full max-w-md">
            <div
              className={`flex items-center border rounded-md px-4 py-2 w-full transition-colors duration-200 ${
                error
                  ? "border-red-500"
                  : "border-gray-300 hover:border-gray-400 focus-within:border-customGreen"
              }`}
            >
              <input
                id="file-upload"
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                className="absolute inset-0 opacity-0 cursor-pointer"
                aria-describedby="file-error"
              />
              <span className="text-sm text-gray-700 truncate flex-1">
                {selectedFile ? selectedFile.name : "Click to select file"}
              </span>

              <svg
                className="w-5 h-5 text-gray-400 mr-2 hover:text-customGreen"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Error Message */}
        {error && (
          <p className="text-sm text-red-600 mb-4" role="alert">
            {error}
          </p>
        )}

        {/* Note and Download Link */}
        <div className="text-sm text-center justify-center flex text-gray-600 mb-6">
          <strong>Note:</strong> Only upload Excel file formats.{" "}
          <div
           onClick={handleDownloadTemplate}
            className="text-blue-500 hover:underline"
          >
            Download Example Template
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-center gap-3">
          <button
            onClick={()=>{
                setSelectedFile(null)
                onClose()
            }}
            className="px-6 py-3 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 text-sm"
            aria-label="Cancel"
          >
            Cancel
          </button>
          <button
            onClick={handleImport}
            className="px-6 py-3 bg-customGreen text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-sm disabled:opacity-50"
            disabled={!selectedFile}
            aria-label="Import file"
          >
            Import
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadModel;
